import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ICON_REGISTRY, IconName } from './icon.registry';

const DEFAULT_ICON_SIZE = 16;

@Component({
    selector: 'app-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            [attr.width]="size"
            [attr.height]="size"
            [attr.viewBox]="viewBox"
            fill="currentColor"
            [innerHTML]="safeContent">
        </svg>
    `,
    styles: [`:host { display: inline-flex; vertical-align: middle; line-height: 0; }`],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
    @Input() name!: IconName;
    @Input() size: number | string = DEFAULT_ICON_SIZE;

    constructor(private readonly sanitizer: DomSanitizer) {}

    get viewBox(): string {
        return ICON_REGISTRY[this.name].viewBox;
    }

    get safeContent(): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(ICON_REGISTRY[this.name].content);
    }
}
